import type { ThinkingLevel } from "@open-hax/eta-mu-agent-core";

export const DEFAULT_THINKING_LEVEL: ThinkingLevel = "medium";
